import { app } from "js/namespaces";
import React, { Component, Fragment } from "reactn";
import LinkAnalyticsPane from "./Panes/LinkAnalyticsPane";
import AnalyticsPane from "./Panes/AnalyticsPane";
import Spinner from "js/react/components/Spinner";
import ErrorMessage from "js/react/components/ErrorMessage";
import analyticsDS from "js/react/views/Analytics/analyticsDataService";
import { FetchStatus } from "js/react/constants";
import "css/analytics.scss";
import { UIPane, UIPaneContents, UIPaneHeader } from "js/react/components/UiComponents";
import { FeatureType } from "js/core/models/features";

class Analytics extends Component {
    componentWillMount() {
        if (app.user.features.isFeatureEnabled(FeatureType.ANALYTICS, this.global.presentation.getWorkspaceId())) {
            analyticsDS.fetchPresentationAnalytics();
            analyticsDS.clearSelectedLink();
        } else {
            analyticsDS.setDummyData();
        }
    }

    render() {
        let { showSelectedLink, status } = this.global.analytics;

        switch (status.type) {
            case FetchStatus.LOADING:
                return (
                    <UIPane>
                        <Spinner />
                    </UIPane>
                );
            case FetchStatus.ERROR:
                return (
                    <UIPane>
                        <ErrorMessage title="An error occurred while loading analytics data" message={status.message} />
                    </UIPane>
                );
            case FetchStatus.SUCCESS:
            default:
                return (
                    <Fragment>
                        <AnalyticsPane />
                        {showSelectedLink ? <LinkAnalyticsPane /> : undefined}
                    </Fragment>
                );
        }
    }
}

export default Analytics;
